<script setup lang="ts">
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import type { DailyLessonViewKollegeUserFragment } from './DailyLessonView.generated'
import { computed } from 'vue'
import CalendarIcon from '@/assets/images/icons/calendar.svg?component'
import { format } from 'date-fns'
import DailyLessonCard from './DailyLessonCard/DailyLessonCard.vue'
import { sortBy } from 'lodash-es'
import DailyLessonStartView from './DailyLessonStartView.vue'

const props = defineProps<{
  user: DailyLessonViewKollegeUserFragment
}>()

const expenseRecordDailyLesson = computed(
  () => props.user.standardCourse?.expenseRecordDailyLesson
)

const formatDate = (date: TimeString | null | undefined) => {
  if (!date) return null
  return format(new Date(date), 'yyyy/MM/dd')
}

const formattedStartsAt = computed(() => {
  return formatDate(expenseRecordDailyLesson.value?.period?.startsAt)
})
const formattedEndsAt = computed(() => {
  return formatDate(expenseRecordDailyLesson.value?.period?.endsAt)
})

const sortedInputs = computed(() => {
  return sortBy(expenseRecordDailyLesson.value?.input, input => {
    return input.nth_day
  })
})
</script>
<template>
  <section v-if="expenseRecordDailyLesson" :class="$style.main">
    <header :class="$style.header">
      <SectionTitle>デイリーレッスン</SectionTitle>
      <div :class="$style.header__subheader">
        <CalendarIcon :class="$style.header__calendar" />
        デイリーレッスン期間:
        <span :class="$style.header__period">
          <time>
            {{ formattedStartsAt }}
          </time>
          〜
          <time>
            {{ formattedEndsAt }}
          </time>
        </span>
      </div>
    </header>
    <main :class="$style.cards">
      <DailyLessonCard
        v-for="dailyLessonInput in sortedInputs"
        :key="dailyLessonInput.guid"
        :dailyLessonInput="dailyLessonInput"
        :user="user"
      />
    </main>
  </section>
  <DailyLessonStartView v-else :class="$style.main" :user="user" />
</template>

<style lang="scss" module>
.header {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__subheader {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  &__calendar {
    width: 24px;
    height: 24px;
    fill: $color-text-and-object-high-emphasis;
  }

  &__period {
    font-weight: bold;
  }
}

.main {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
</style>
